import { AxiosError } from 'axios';
import LayoutContext from 'components/Layout/LayoutContext';
import EditarNucleo from 'components/Modal/CadastroEvento/Etapas/Entidade/EditarNucleo';
import { AuthContext } from 'context/authContext/AuthContext';
import { RegisterContextActions } from 'context/registerContext/RegisterContextActions';
import {
  AssemblyModalities,
  SituationValues,
  StepIds,
  StepStatus,
} from 'helpers/enums/Assembleia';
import { getProfileByJWTRoles } from 'helpers/utils/AuthUtils';
import { clsx } from 'helpers/utils/HTMLUtils';
import {
  getParsedJWTAssessorAccessToken,
  JWTAssessorJson,
} from 'helpers/utils/JWTUtils';
import { getUniqueKey } from 'helpers/utils/KeyUtils';
import { useRegisterContext } from 'hooks/useRegisterContext';
import {
  AssessorCadastroEventoRoutePath,
  AssessorCadastroReuniaoRoutePath,
} from 'library/Routes';
import translation from 'locales/translation';
import {
  ActionsColumn,
  AddCircleIcon,
  ArrowLeftIcon,
  Button,
  ButtonThemes,
  CheckCircleIcon,
  ChevronArrowDownIcon,
  Col,
  Collapse,
  ConfirmModal,
  EditIcon,
  LeftCheckboxWithLabel,
  ModalSizes,
  Pagination,
  Row,
  ScreenSize,
  Select,
  Table,
  Title,
  ToastTypes,
  TrashIcon,
} from 'plataforma-fundacao-componentes';
import {
  BaseSyntheticEvent,
  Fragment,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import {
  getAgendaRegister,
  getNucleuses,
  postEntitiesStep,
} from 'services/assessor';
import {
  AuthUserPerfilId,
  IAuthUserPerfil,
} from 'store/modules/auth/IAuthUserPerfil';
import { closeModal, openModal } from 'store/modules/ModalActions';
import { makeEditable } from '../../Cadastro';
import {
  EntitiesValidation,
  EntitiesValidationType,
} from './EntitiesValidation';
import styles from './styles.module.scss';

type Nucleus = {
  id: number;
  code: string;
};

type SelectType = { label: string; value: string };

const entitiesPrefix = translation.Assessor.Evento.Cadastro.Etapas.Entidade;

export const getNucleusByKey = (obj: any, key?: string): Nucleus[] => {
  const nucleu: Nucleus[] = [];

  if (key && obj.nucleuses) {
    const nucleuses = obj.nucleuses[key as keyof typeof obj.nucleuses];

    if (Array.isArray(nucleuses)) {
      nucleu.push(...nucleuses);
    }

    return nucleu;
  } else {
    for (const objKey in obj) {
      if (
        Object.prototype.hasOwnProperty.call(obj, objKey) &&
        typeof objKey === 'string'
      ) {
        const nucleuses = obj[objKey];

        if (Array.isArray(nucleuses)) {
          nucleu.push(...nucleuses);
        }
      }
    }

    return nucleu;
  }
};

export const getValuesForIds = (
  data: { [key: string]: { id: number; code: string }[] },
  ids: number[]
) => {
  const result: { id: number; code: string }[] = [];

  Object.values(data).forEach((items: { id: number; code: string }[]) => {
    items.forEach((item: { id: number; code: string }) => {
      if (ids.includes(item.id)) {
        result.push(item);
      }
    });
  });

  return result;
};

// eslint-disable-next-line unused-imports/no-unused-vars
export default function Entities(props: { reu?: boolean }) {
  const [previousRequest, setPreviousRequest] =
    useState<AbortController | null>(null);
  const [showButton, setShowButton] = useState<boolean>(true);
  const [loaderTable, setLoaderTable] = useState<boolean>(false);
  const [editButtonLoader, setEditButtonLoader] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [opened, setOpened] = useState<boolean | number>(false);
  const [calledOnce, hasCalledOnce] = useState<number>(0);
  const [selected, setSelected] = useState<string[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize] = useState<number>(10);
  const [validator, setValidator] = useState<EntitiesValidationType | null>(
    null
  );
  const [sent, setSent] = useState<boolean>(false);

  const { user } = useContext(AuthContext);
  const match = useRouteMatch<{ id?: string; etapa?: string }>();
  const dispatchAction = useDispatch();
  const {
    state,
    entitiesStepSetFilter,
    changeState,
    setStepCompleted,
    setStepId,
    setStepStatus,
  } = useRegisterContext();
  const { showToast } = useContext(LayoutContext);

  const history = useHistory();

  const completedStep =
    state.completed.find(
      (item: { step: StepIds }) => item.step === StepIds.entity
    )?.completed && state.status !== StepStatus.EM_EDICAO;

  const indexOfLastData = currentPage * pageSize;
  const indexOfFirstData = indexOfLastData - pageSize;
  const currentDataTable =
    state.entities.tableData.length > 10
      ? state.entities.tableData.slice(indexOfFirstData, indexOfLastData)
      : state.entities.tableData;

  const filteredAgn: any = state.entities.agencyOptions.filter(
    (agn: { label: string; value: string }) =>
      !state.entities.tableData.some(
        (x: { agn: { label: string; value: string } }) =>
          x.agn === undefined ? '01' === agn.value : x.agn.value === agn.value
      )
  );

  const handleFilter = () => {
    setSelected([]);
    if (!sent) setSent(true);
    if (!validator || !validator.allIsValid()) return;
    if (showButton) {
      setLoaderTable(true);
    }

    setTimeout(
      () => {
        setShowButton(false);
        hasCalledOnce((e) => e + 1);
        setLoaderTable(false);
        setSent(false);

        changeState(
          RegisterContextActions.ENTITIES_TABLE_DATA,
          !state.entities.tableData.length
            ? state.entities.inputs.agency.map((agencies: string) => {
                return {
                  id: `id-${getUniqueKey()}`,
                  agn: state.entities.agencyOptions.filter(
                    (item: { value: string }) => item.value === agencies
                  )[0],
                  nuc:
                    (filteredAgn.length ===
                      state.entities.inputs.agency.length &&
                      filteredAgn.length > 1 &&
                      state.entities.inputs.agency.length > 1) ||
                    completedStep
                      ? getNucleusByKey(
                          state.entities.nucleouOptions,
                          String(agencies)
                        ).map((result) => result)
                      : getValuesForIds(
                          state.entities.nucleouOptions.nucleuses,
                          state.entities.inputs.nucleou
                        ),
                };
              })
            : [
                ...state.entities.tableData,
                ...state.entities.inputs.agency.map((agencies: string) => {
                  return {
                    id: `id-${getUniqueKey()}`,
                    agn: state.entities.agencyOptions.filter(
                      (item: { value: string }) => item.value === agencies
                    )[0],
                    nuc:
                      (filteredAgn.length ===
                        state.entities.inputs.agency.length &&
                        filteredAgn.length > 1 &&
                        state.entities.inputs.agency.length > 1) ||
                      completedStep
                        ? getNucleusByKey(
                            state.entities.nucleouOptions,
                            String(agencies)
                          ).map((result) => result)
                        : getValuesForIds(
                            state.entities.nucleouOptions.nucleuses,
                            state.entities.inputs.nucleou
                          ),
                  };
                }),
              ]
        );

        if (!completedStep) {
          changeState(
            RegisterContextActions.ENTITIES_ALL_NUCLEOU_PER_AGENCY,
            !state.entities.allNucPerAgency
              ? state.entities.inputs.agency.map((agencies) => {
                  return {
                    agn: agencies,
                    nuc: getNucleusByKey(
                      state.entities.nucleouOptions,
                      String(agencies)
                    ).map((result) => result),
                  };
                })
              : [
                  ...state.entities.allNucPerAgency,
                  ...state.entities.inputs.agency.map((agencies) => {
                    return {
                      agn: agencies,
                      nuc: getNucleusByKey(
                        state.entities.nucleouOptions,
                        String(agencies)
                      ).map((result) => result),
                    };
                  }),
                ]
          );

          changeState(RegisterContextActions.ENTITIES_FILTER_SET, {
            agency: [],
            nucleou: [],
          });
        }
      },
      showButton ? 500 : 100
    );
  };

  const whichPage = () => {
    if (
      [
        AssemblyModalities.OFFLINE,
        AssemblyModalities.HIBRIDO_PRESENCIAL_DIGITAL,
        AssemblyModalities.HIBRIDO_SIMULTANEO,
      ].includes(state.data.campos.modality!)
    ) {
      if (props.reu) {
        history.push(
          `${AssessorCadastroReuniaoRoutePath}${match.params.id}/etapas/local`
        );
      } else {
        history.push(
          `${AssessorCadastroEventoRoutePath}${match.params.id}/etapas/local`
        );
      }
    } else {
      if (props.reu) {
        history.push(
          `${AssessorCadastroReuniaoRoutePath}${match.params.id}/etapas/pauta`
        );
      } else {
        history.push(
          `${AssessorCadastroEventoRoutePath}${match.params.id}/etapas/pauta`
        );
      }
    }
  };

  const handleSubmit = () => {
    if (completedStep) {
      whichPage();
    } else {
      const request = {
        eventId: Number(match.params.id),
        selectedNucleuses: state.entities.tableData.reduce(
          (
            result: { [key: string]: number[] },
            item: {
              id: string;
              agn: { label: string; value: string };
              nuc: { id: number; code: string }[];
            }
          ) => {
            const key = item.agn.value;
            const values = item.nuc.map(
              (nucItem: { id: number }) => nucItem.id
            );

            result[key] = values;
            return result;
          },
          {}
        ),
      };

      setLoading(true);

      if (
        JSON.stringify(state.entities.tableData) ===
        JSON.stringify(state.entitiesOld.tableData)
      ) {
        whichPage();
      } else {
        postEntitiesStep(request)
          .then(() => {
            setLoading(false);
            setStepCompleted(
              state.completed.map(
                (item: { step: StepIds; completed: boolean }) =>
                  item.step === StepIds.entity
                    ? { ...item, completed: true }
                    : item
              )
            );

            changeState(
              RegisterContextActions.ENTITIES_TABLE_DATA_OLD,
              state.entities.tableData
            );

            getAgendaRegister(Number(match.params.id))
              .then((table) => {
                changeState(
                  RegisterContextActions.STAVES_TABLE_DATA,
                  table.data
                );
                changeState(
                  RegisterContextActions.STAVES_INITIAL_TABLE_DATA,
                  table.data
                );
              })
              .catch(() => {});

            if (state.showAlert) {
              history.push(state.toPage);
            } else {
              if (
                [
                  AssemblyModalities.OFFLINE,
                  AssemblyModalities.HIBRIDO_PRESENCIAL_DIGITAL,
                  AssemblyModalities.HIBRIDO_SIMULTANEO,
                ].includes(state.data.campos.modality!)
              ) {
                if (props.reu) {
                  history.push(
                    `${AssessorCadastroReuniaoRoutePath}${match.params.id}/etapas/local`
                  );
                } else {
                  history.push(
                    `${AssessorCadastroEventoRoutePath}${match.params.id}/etapas/local`
                  );
                }
              } else {
                if (props.reu) {
                  history.push(
                    `${AssessorCadastroReuniaoRoutePath}${match.params.id}/etapas/pauta`
                  );
                } else {
                  history.push(
                    `${AssessorCadastroEventoRoutePath}${match.params.id}/etapas/pauta`
                  );
                }
              }
            }
          })
          .catch((err) => {
            setLoading(false);
            showToast({
              pauseOnFocusLoss: true,
              theme: ToastTypes.Error,
              showStatusBar: true,
              timeout: 4000,
              label:
                translation.Toasts.Errors.Keys[
                  `${
                    (err as AxiosError<Error>).response?.data.message ||
                    (err as AxiosError<Error>).response?.data ||
                    (err as AxiosError<Error>).message
                  }` as keyof typeof translation.Toasts.Errors.Keys
                ] ?? translation.Toasts.Errors.defaultAlternative,
            });
          });
      }
    }
  };

  const deleteUpperHeaderButton = useCallback(
    (id: string | string[]) => {
      let filteredArray = state.entities.tableData.filter(
        (item: { id: string }) => !id.includes(item.id)
      );

      return {
        icon: <TrashIcon />,
        label: entitiesPrefix.Table.UpperHeader.Deletar,
        onClick: () => {
          const mk = getUniqueKey();

          dispatchAction(
            openModal(ConfirmModal, {
              modalKey: mk,
              title: entitiesPrefix.Modal.Deletar.Title,
              size: ModalSizes.Large,
              mobileOn: ScreenSize.xs,
              children:
                selected.length > 1
                  ? entitiesPrefix.Modal.Deletar.Mensagem.many
                  : entitiesPrefix.Modal.Deletar.Mensagem.one,

              onClose: () => {
                dispatchAction(closeModal(mk));
              },
              onCancel: () => {
                dispatchAction(closeModal(mk));
              },
              onConfirm: () => {
                return new Promise<void>(
                  (resolve: () => void, reject: () => void) => {
                    try {
                      setTimeout(() => {
                        changeState(
                          RegisterContextActions.ENTITIES_TABLE_DATA,
                          filteredArray
                        );
                        dispatchAction(closeModal(mk));
                        setSelected([]);
                        if (selected.length === currentDataTable.length) {
                          setCurrentPage(1);
                        }

                        resolve();
                      }, 750);
                    } catch (err) {
                      reject();
                      console.error(err);
                    }
                  }
                );
              },
            })
          );
        },
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selected]
  );

  const editModal = (id: string | string[]) => {
    const mk: any = getUniqueKey();

    const nucOptions: any = state.entities.tableData.filter(
      (item: { id: string; agn: string; nuc: string[] }) => item.id === id[0]
    )[0];

    const updateValues = (values: { id: number; code: string }[]) => {
      const newState = state.entities.tableData.map(
        (obj: {
          id: string;
          agn: string;
          nuc: { id: number; code: string }[];
        }) => {
          if (obj.id === id[0]) {
            return { ...obj, nuc: values };
          }

          return obj;
        }
      );

      changeState(RegisterContextActions.ENTITIES_TABLE_DATA, newState);
    };

    return dispatchAction(
      openModal(EditarNucleo, {
        modalKey: mk,
        title: entitiesPrefix.Modal.Editar.Title,
        size: ModalSizes.Large,
        mobileOn: ScreenSize.xs,
        preventMaskExit: true,
        agency: nucOptions && nucOptions.agn,
        nucleou:
          nucOptions &&
          nucOptions.nuc.map((item: { id: number; code: string }) => item),
        nucleouOptions: state.entities.allNucPerAgency as any,
        onClose: () => setSelected([]),
        onConfirm: (values) => {
          setSelected([]);
          updateValues(values);
        },
      })
    );
  };

  useEffect(() => {
    setStepId(StepIds.entity);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (completedStep) {
      setShowButton(false);
    } else if (
      (state.eventStatus === SituationValues.AVAILABLE &&
        state.status === StepStatus.EM_EDICAO) ||
      ((state.eventStatus === SituationValues.EDITABLE ||
        state.status === StepStatus.EM_EDICAO) &&
        state.entities.tableData.length)
    ) {
      setShowButton(false);
    } else {
      if (!state.entities.tableData.length) {
        setShowButton(true);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [completedStep, state.entities.tableData]);

  useEffect(() => {
    if (!match.params.id) {
      setTimeout(() => {
        if (props.reu) {
          history.push(`${AssessorCadastroReuniaoRoutePath}etapas/dados`);
        } else {
          history.push(`${AssessorCadastroEventoRoutePath}etapas/dados`);
        }
      }, 200);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [match, props.reu]);

  useEffect(() => {
    setValidator(EntitiesValidation(state));
  }, [state]);

  useEffect(() => {
    if (validator && validator.allIsValid()) {
      setSent(false);
    }
  }, [validator, validator?.allIsValid]);

  const loadNucleuses = async (
    cooperative: string,
    branch: string[],
    { toast }: any,
    label: string,
    setPrevious: (controller: AbortController | null) => void
  ) => {
    const controller = new AbortController();
    const signal = controller.signal;

    setPrevious(controller);

    changeState(RegisterContextActions.ENTITIES_NUCLEOU_LOAD, true);

    return getNucleuses(cooperative, branch, { signal })
      .then(({ data }) => {
        changeState(RegisterContextActions.ENTITIES_NUCLEOU, data);
      })
      .catch((err) => {
        if (err.code !== 'ERR_CANCELED') {
          toast({
            pauseOnFocusLoss: true,
            theme: ToastTypes.Error,
            showStatusBar: true,
            timeout: 4000,
            label,
          });
        }
      })
      .finally(() => {
        changeState(RegisterContextActions.ENTITIES_NUCLEOU_LOAD, false);
      });
  };

  useEffect(() => {
    if ([StepStatus.CRIACAO, StepStatus.EM_EDICAO].includes(state.status)) {
      const controller = new AbortController();

      if (previousRequest) {
        previousRequest.abort();
      }

      setPreviousRequest(controller);

      if (!completedStep) {
        if (state.entities.inputs.agency.length) {
          loadNucleuses(
            state.data.campos.cooperative,
            state.entities.inputs.agency!,
            { showToast },
            translation.Toasts.Errors.loadNucleou,
            setPreviousRequest
          );
        }
      }

      return () => {
        if (previousRequest) {
          previousRequest.abort();
        }
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.entities.inputs.agency]);

  useEffect(() => {
    if (!completedStep) {
      if (
        state.entities.inputs.agency.length > 1 &&
        filteredAgn.length > 1 &&
        state.entities.inputs.agency.length === filteredAgn.length
      ) {
        changeState(
          RegisterContextActions.ENTITIES_NUCLEOU,
          getNucleusByKey(state.entities.nucleouOptions.nucleuses)
        );
      } else {
        changeState(
          RegisterContextActions.ENTITIES_NUCLEOU,
          getNucleusByKey(state.entities.nucleouOptions.nucleuses).map(
            (item: { code: string }) => item.code
          )
        );
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.entities.inputs.agency.length]);

  useEffect(() => {
    if (!completedStep) {
      if (
        state.entities.inputs.agency.length > 1 &&
        filteredAgn.length > 1 &&
        state.entities.inputs.agency.length === filteredAgn.length
      ) {
        changeState(RegisterContextActions.ENTITIES_FILTER_SET, {
          nucleou: getNucleusByKey(state.entities.nucleouOptions.nucleuses).map(
            (x: { id: number }) => x.id
          ),
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.entities.nucleouOptions]);

  const parsedToken: JWTAssessorJson | null = getParsedJWTAssessorAccessToken(
    user!.access_token
  );

  const perfil: IAuthUserPerfil | null = parsedToken
    ? getProfileByJWTRoles(parsedToken.roles)
    : null;

  useEffect(() => {
    if (
      state.showAlert &&
      (state.status === StepStatus.EM_EDICAO ||
        state.eventStatus === SituationValues.EDITABLE)
    ) {
      const mk = getUniqueKey();

      dispatchAction(
        openModal(ConfirmModal, {
          modalKey: mk,
          size: ModalSizes.Large,
          title: 'Confirmação',
          mobileOn: ScreenSize.xs,
          children:
            'Há modificações que ainda não foram salvas. Você deseja salvar essas alterações antes de alterar a etapa atual?',
          onClose: () => {
            changeState(RegisterContextActions.SET_SHOW_ALERT, false);
            dispatchAction(closeModal(mk));
          },
          onCancel: () => {
            changeState(RegisterContextActions.SET_SHOW_ALERT, false);
            history.push(state.toPage);
            changeState(
              RegisterContextActions.ENTITIES_TABLE_DATA,
              state.entitiesOld.tableData
            );
            dispatchAction(closeModal(mk));
          },
          onConfirm: () => {
            changeState(RegisterContextActions.SET_SHOW_ALERT, false);
            dispatchAction(closeModal(mk));
            handleSubmit();
          },
          language: {
            confirm: 'Salvar',
            cancel: 'Não salvar',
          },
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.showAlert]);

  return match.params.id ? (
    <Row className={styles.root}>
      <Row className={styles.title_content}>
        <Col cols={[12, 12, 6, 6, 6]}>
          <Title>{entitiesPrefix.Titulo}</Title>
        </Col>
        {[SituationValues.AVAILABLE, SituationValues.IN_PREPARATION].includes(
          state.eventStatus!
        ) &&
        ((state.status !== StepStatus.EM_EDICAO &&
          [AuthUserPerfilId.PertencerConsulta].includes(perfil!?.id!) &&
          props.reu) ||
          ![AuthUserPerfilId.PertencerConsulta].includes(perfil!?.id!)) ? (
          <Col cols={[12, 12, 6, 6, 6]} end buttonActionsCol>
            <Button
              theme={ButtonThemes.Primary}
              leftIcon={<EditIcon />}
              onClick={() => {
                setEditButtonLoader(true);
                makeEditable(
                  String(match.params.id),
                  () => {
                    setEditButtonLoader(false);
                    setStepStatus(StepStatus.EM_EDICAO);
                    changeState(
                      RegisterContextActions.SET_EVENT_STATUS,
                      SituationValues.EDITABLE
                    );
                  },
                  (error) => {
                    setEditButtonLoader(false);
                    showToast({
                      pauseOnFocusLoss: true,
                      theme: ToastTypes.Error,
                      showStatusBar: true,
                      timeout: 4000,
                      label:
                        translation.Toasts.Errors.Keys[
                          `${
                            (error as AxiosError<Error>).response?.data
                              .message ||
                            (error as AxiosError<Error>).response?.data ||
                            (error as AxiosError<Error>).message
                          }` as keyof typeof translation.Toasts.Errors.Keys
                        ] ?? translation.Toasts.Errors.defaultAlternative,
                    });
                  }
                );
              }}
              disabled={editButtonLoader}
              loading={editButtonLoader}
            >
              {entitiesPrefix.Buttons.Editar}
            </Button>
          </Col>
        ) : undefined}
        <Col>
          <p>{entitiesPrefix.Subtitulo}</p>
        </Col>
        {state.data.campos.flgEventTest ? (
          <Col>
            <span style={{ color: '#e60000', fontSize: '12px' }}>
              {translation.Assessor.Evento.Cadastro.Etapas.Dados.EventoTeste}
            </span>
          </Col>
        ) : (
          <Fragment />
        )}
      </Row>
      <Row>
        <Col>
          <Select
            data-testid={'select-cooperativa'}
            label={entitiesPrefix.Campos.Cooperativa.Label}
            placeholder={entitiesPrefix.Campos.Cooperativa.Placeholder}
            options={state.data.cooperativeOptions}
            value={state.data.campos.cooperative}
            onChange={() => {
              return;
            }}
            preSelectUniqueOption
            disabled={true}
            clearButton={false}
          />
        </Col>
        <Col cols={[12, 6, 6, 6, 6]}>
          <Select
            data-testid={'select-agencia'}
            label={entitiesPrefix.Campos.Agencia.Label}
            placeholder={entitiesPrefix.Campos.Agencia.Placeholder}
            options={state.entities.agencyOptions.filter(
              (agn: { label: string; value: string }) =>
                !state.entities.tableData.some(
                  (x: { agn: { value: string } }) =>
                    x.agn === undefined
                      ? '01' === agn.value
                      : x.agn.value === agn.value
                )
            )}
            value={state.entities.inputs.agency}
            onChange={(agency) => {
              const lengthEqual =
                state.entities.inputs.agency.length ===
                state.entities.agencyOptions.length
                  ? [filteredAgn[0]!?.value!]
                  : [agency.slice(-1)[0]];

              entitiesStepSetFilter({
                agency:
                  agency.length === filteredAgn.length
                    ? agency
                    : agency.values().next().value === undefined
                    ? agency
                    : lengthEqual,
                nucleou: [],
              });
              changeState(RegisterContextActions.ENTITIES_NUCLEOU, []);
            }}
            multiple
            panelFilter
            loading={
              state.status !== StepStatus.VISUALIZACAO &&
              state.entities.agencyLoading
            }
            disabled={
              state.status === StepStatus.VISUALIZACAO ||
              completedStep ||
              state.entities.agencyLoading ||
              !state.data.campos.cooperative
            }
            clearButton={!completedStep}
            error={sent && !!validator && validator.agencyIsValid().error}
            helperText={
              sent && !!validator ? validator.agencyIsValid().helperText : ''
            }
          />
        </Col>
        <Col cols={[12, 6, 6, 6, 6]}>
          <Select
            data-testid={'select-nucleo'}
            label={entitiesPrefix.Campos.Nucleo.Label}
            placeholder={entitiesPrefix.Campos.Nucleo.Placeholder}
            options={
              state.entities.inputs.agency.length > 1 &&
              state.entities.agencyOptions.length > 1 &&
              state.entities.inputs.agency.length ===
                state.entities.agencyOptions.length
                ? state.entities.nucleouOptions &&
                  getNucleusByKey(state.entities.nucleouOptions.nucleuses)
                    ?.map((x: { code: string; id: number }) => {
                      return {
                        label: x.code,
                        value: x.id,
                      };
                    })
                    .sort((a: { label: string }, b: { label: string }) =>
                      a.label < b.label ? -1 : 1
                    )
                : getNucleusByKey(state.entities.nucleouOptions.nucleuses)
                    ?.map((x: { code: string; id: number }) => {
                      return {
                        label: x.code,
                        value: x.id,
                      };
                    })
                    .sort((a: { label: string }, b: { label: string }) =>
                      a.label < b.label ? -1 : 1
                    )
            }
            value={state.entities.inputs.nucleou}
            onChange={(nucleou) => {
              entitiesStepSetFilter({
                nucleou: nucleou,
              });
            }}
            multiple
            loading={
              state.status !== StepStatus.VISUALIZACAO &&
              state.entities.nucleouLoading
            }
            readOnly={
              state.entities.inputs.agency.length > 1 &&
              filteredAgn.length > 1 &&
              state.entities.inputs.agency.length === filteredAgn.length
            }
            disabled={
              state.status === StepStatus.VISUALIZACAO ||
              completedStep ||
              !state.data.campos.cooperative ||
              !state.entities.inputs.agency.length ||
              state.entities.nucleouLoading
            }
            error={sent && !!validator && validator.nucleouIsValid().error}
            clearButton={false}
            helperText={
              sent && !!validator ? validator.nucleouIsValid().helperText : ''
            }
          />
        </Col>
      </Row>
      <Row>
        <Col end buttonActionsCol>
          <CSSTransition
            in={showButton}
            timeout={300}
            unmountOnExit
            mountOnEnter
            classNames={{
              enter: styles.enter,
              enterActive: styles.enterActive,
              enterDone: styles.enterDone,
              exit: styles.exit,
              exitActive: styles.exitActive,
              exitDone: styles.exitDone,
            }}
          >
            <Button
              className={clsx([
                styles.appearButton,
                calledOnce <= 0 ? styles.show : '',
              ])}
              theme={ButtonThemes.Secondary}
              onClick={() => {
                if (props.reu) {
                  history.push(
                    `${AssessorCadastroReuniaoRoutePath}${
                      match.params.id
                        ? `${match.params.id}/etapas/dados`
                        : `etapas/${StepIds.data}`
                    }`
                  );
                } else {
                  history.push(
                    `${AssessorCadastroEventoRoutePath}${
                      match.params.id
                        ? `${match.params.id}/etapas/dados`
                        : `etapas/${StepIds.data}`
                    }`
                  );
                }
              }}
              leftIcon={<ArrowLeftIcon />}
            >
              {entitiesPrefix.Buttons.Voltar}
            </Button>
          </CSSTransition>
          {state.status === StepStatus.VISUALIZACAO &&
          !state.entities.tableData.length ? (
            <Button theme={ButtonThemes.Primary} onClick={whichPage}>
              {entitiesPrefix.Buttons.Prosseguir}
            </Button>
          ) : (
            <Button
              theme={ButtonThemes.Primary}
              onClick={handleFilter}
              leftIcon={<AddCircleIcon />}
              disabled={!completedStep ? sent || loaderTable : true}
              loading={loaderTable}
            >
              {entitiesPrefix.Buttons.Adicionar}
            </Button>
          )}
        </Col>
      </Row>
      <Collapse
        opened={
          !completedStep
            ? !showButton && Boolean(state.entities.tableData.length)
            : state.eventStatus === SituationValues.EDITABLE
            ? !showButton && Boolean(state.entities.tableData.length)
            : Boolean(state.entities.tableData.length)
        }
        animateOpacity
      >
        <Row>
          <Col>
            <Table
              columns={[
                {
                  key: 'checkbox',
                  props: {
                    style: {
                      width: '500px',
                    },
                  },
                  value: (
                    <LeftCheckboxWithLabel
                      anchorLabelToCheckbox={!completedStep && !loading}
                      label={entitiesPrefix.Table.Head.Agencia}
                      value={
                        Boolean(selected!?.length) &&
                        selected!?.length === currentDataTable!?.length
                      }
                      onChange={(val) => {
                        if (!completedStep && !loading) {
                          if (val) {
                            setSelected(
                              currentDataTable!?.map(
                                (a: { id: string }) => a.id
                              )
                            );
                          } else {
                            setSelected([]);
                          }
                        }
                      }}
                      disabled={completedStep || loading}
                    />
                  ),
                },
                {
                  key: 'nucleou',
                  value: entitiesPrefix.Table.Head.Nucleo,
                  props: {
                    align: 'left',
                    style: {
                      width: '50%',
                      transition: '0.3s ease-in-out',
                    },
                  },
                },
                { key: 'actions', value: '' },
              ]}
              lines={currentDataTable
                .sort(
                  (
                    o1: { agn: { label: string } },
                    o2: { agn: { label: string } }
                  ) => (o1.agn?.label! < o2.agn?.label! ? -1 : 1)
                )!
                ?.map(
                  (
                    row: {
                      agn: SelectType;
                      id: string;
                      nuc: { id: number; code: string }[];
                    },
                    index: number
                  ) => {
                    return {
                      key: index,
                      props: {
                        className:
                          row.nuc.length! > 7 ? styles.row : styles.maxWidth,
                        onClick:
                          row.nuc.length! > 7
                            ? (e: Event | BaseSyntheticEvent) => {
                                setOpened((prev) =>
                                  prev === index ? false : index
                                );
                                e.stopPropagation();
                              }
                            : undefined,
                      },
                      checkbox: (
                        <div
                          className={styles.rowAgn}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <LeftCheckboxWithLabel
                            label={row.agn!?.label!}
                            value={selected!?.indexOf(row.id)! > -1}
                            onChange={(v) => {
                              if (!completedStep && !loading) {
                                let sel = [...selected!];
                                if (v) {
                                  sel.push(row.id);
                                } else {
                                  sel = sel.filter((aa) => aa !== row.id);
                                }
                                setSelected(sel);
                              }
                            }}
                            anchorLabelToCheckbox={!completedStep && !loading}
                            disabled={completedStep || loading}
                          />
                        </div>
                      ),
                      nucleou: (
                        <div>
                          <Fragment>
                            <Collapse opened={opened !== index} animateOpacity>
                              {row.nuc.length
                                ? row.nuc
                                    .sort(
                                      (
                                        item1: { code: string },
                                        item2: { code: string }
                                      ) => {
                                        return item1.code < item2.code ? -1 : 1;
                                      }
                                    )
                                    .map(
                                      (x: { code: string }, index: number) => {
                                        return (
                                          <Fragment key={index}>
                                            {(index ? ', ' : '') + x.code}
                                          </Fragment>
                                        );
                                      }
                                    )

                                    .slice(0, 7)
                                : '-'}
                              {row!?.nuc!?.length! > 7 ? '...' : ''}
                            </Collapse>
                            <Collapse opened={opened === index} animateOpacity>
                              {row.nuc
                                ? row.nuc
                                    .sort(
                                      (
                                        item1: { code: string },
                                        item2: { code: string }
                                      ) => {
                                        return item1.code < item2.code ? -1 : 1;
                                      }
                                    )!
                                    ?.map(
                                      (x: { code: string }, index: number) => {
                                        return (
                                          <Fragment key={index}>
                                            {String(
                                              (index ? ', ' : '') + x.code
                                            )}
                                          </Fragment>
                                        );
                                      }
                                    )
                                : '-'}
                            </Collapse>
                          </Fragment>
                        </div>
                      ),
                      actions: (
                        <ActionsColumn
                          buttons={[
                            {
                              icon: (
                                <div
                                  className={clsx([
                                    styles.chevron,
                                    opened === index ? styles.active : '',
                                    row!?.nuc!?.length! <= 7
                                      ? styles.disabled
                                      : '',
                                  ])}
                                >
                                  <ChevronArrowDownIcon />
                                </div>
                              ),
                              onClick: (e) => {
                                setOpened((prev) =>
                                  prev === index ? false : index
                                );
                                e.stopPropagation();
                              },
                              disabled: row!?.nuc!?.length! <= 7,
                            },
                          ]}
                        />
                      ),
                    };
                  }
                )}
              upperHeader={{
                active: !completedStep && Boolean(selected!?.length),
                buttons:
                  selected!?.length > 1
                    ? [deleteUpperHeaderButton(selected)]
                    : [
                        {
                          icon: <EditIcon />,
                          label: entitiesPrefix.Table.UpperHeader.Editar,
                          onClick: () =>
                            !completedStep && !loading
                              ? editModal(selected)
                              : undefined,
                          disabled: selected!?.length! > 1,
                        },
                        deleteUpperHeaderButton(selected),
                      ],
              }}
            />
          </Col>
          <Col className={styles.paginationContainer}>
            <Pagination
              totalPages={state.entities.tableData.length / pageSize}
              currentPage={currentPage}
              onPageChange={(_, val) => {
                setCurrentPage(val);
                setSelected([]);
              }}
              countPages={{
                rows: pageSize,
                totalItems: state.entities.tableData.length,
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col buttonActionsCol end>
            <Button
              theme={ButtonThemes.Secondary}
              onClick={() => {
                changeState(
                  RegisterContextActions.SET_SHOW_ALERT,
                  JSON.stringify(state.entitiesOld.tableData) !==
                    JSON.stringify(state.entities.tableData)
                );
                if (props.reu) {
                  changeState(
                    RegisterContextActions.SET_TO_PAGE,
                    `${AssessorCadastroReuniaoRoutePath}${
                      match.params.id
                        ? `${match.params.id}/etapas/dados`
                        : `etapas/${StepIds.data}`
                    }`
                  );
                } else {
                  changeState(
                    RegisterContextActions.SET_TO_PAGE,
                    `${AssessorCadastroEventoRoutePath}${
                      match.params.id
                        ? `${match.params.id}/etapas/dados`
                        : `etapas/${StepIds.data}`
                    }`
                  );
                }

                if (
                  JSON.stringify(state.entitiesOld.tableData) ===
                  JSON.stringify(state.entities.tableData)
                ) {
                  if (props.reu) {
                    history.push(
                      `${AssessorCadastroReuniaoRoutePath}${match.params.id}/etapas/dados`
                    );
                  } else {
                    history.push(
                      `${AssessorCadastroEventoRoutePath}${match.params.id}/etapas/dados`
                    );
                  }
                }
              }}
              leftIcon={<ArrowLeftIcon />}
            >
              {entitiesPrefix.Buttons.Voltar}
            </Button>
            <Button
              theme={ButtonThemes.Primary}
              onClick={handleSubmit}
              loading={loading}
              disabled={
                !completedStep
                  ? !state.entities.tableData.length || loading
                  : false
              }
              leftIcon={<CheckCircleIcon />}
            >
              {completedStep
                ? entitiesPrefix.Buttons.Prosseguir
                : entitiesPrefix.Buttons.Salvar}
            </Button>
          </Col>
        </Row>
      </Collapse>
    </Row>
  ) : (
    <Fragment></Fragment>
  );
}
